export default __webpack_public_path__ + "static/media/12.57f417ea.webp";